import React from 'react';
import FillerGauge from '@splunk/dashboard-visualizations/FillerGauge';

export default () => (
    <FillerGauge
        options={{}}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'count' }],
                    columns: [['78']],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
